import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const checklistItems = ['Gradación por Perfil Sensorial', 'Aplicación en Consultorio, Escuela y Casa', '8 Módulos organizados', '40 herramientas con indicadores de progreso', 'Protocolos paso a paso'];
export function TransitionBlock() {
  return <section className="bg-brand-mint py-16 px-6" data-id="element-174">
      <div className="max-w-3xl mx-auto text-center" data-id="element-175">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-display font-black text-4xl md:text-5xl lg:text-6xl uppercase mb-4 text-brand-ink" data-id="element-176">
          ¿Por Qué Este Sistema Es Diferente?
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-600 mb-10 font-medium" data-id="element-177">
          Porque no es una lista de actividades.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        x: -60,
        rotateY: -15
      }} whileInView={{
        opacity: 1,
        x: 0,
        rotateY: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="bg-white rounded-lg p-8 md:p-10 shadow-sm text-left max-w-xl mx-auto border-t-4 border-brand-green relative overflow-hidden" style={{
        transformStyle: 'preserve-3d'
      }} data-id="element-178">
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-green to-brand-green-dark origin-left" data-id="element-179" />

          <motion.p initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="font-display font-bold text-2xl uppercase text-brand-ink mb-6" data-id="element-180">
            Es un método estructurado con:
          </motion.p>
          <ul className="space-y-4" data-id="element-181">
            {checklistItems.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.7 + index * 0.1,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex items-start gap-3" data-id="element-182">
                <motion.div initial={{
              scale: 0,
              rotate: -180
            }} whileInView={{
              scale: 1,
              rotate: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.8 + index * 0.1,
              type: 'spring',
              stiffness: 200,
              damping: 15
            }} data-id="element-183">
                  <CheckIcon className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" data-id="element-184" />
                </motion.div>
                <motion.span initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.9 + index * 0.1
            }} className="text-lg text-gray-700 font-medium" data-id="element-185">
                  {item}
                </motion.span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}